import { api, baseUrl } from "../../api";


export const getAllPieChartApi = async ()=>{
    const result = await api.get(`${baseUrl}/admin/dashboard`);
    return result.data;
}